import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { login, logout, isLoggedIn, ifAdmin, ifSprzedawca} from '../utils/AuthService';
import '../App.css';

var userProfile;

class Nav extends Component {

  render() {

    return (
      <nav className="navbar navbar-default">
        <div className="navbar-header">
          <Link className="navbar-brand" to="/">Usługi ramiarskie</Link>
        </div>

        <ul className="nav navbar-nav">
          <li>
            {
              ( isLoggedIn() && (ifAdmin() || ifSprzedawca()) ) ? <Link to="/zlecenie">Zlecenia</Link> :  ''
            }
          </li>
          <li>
            {
              ( isLoggedIn() ) ? <Link to="/stanListwy">Stan Listw</Link> :  ''
            }
          </li>
          <li>
            {
              ( isLoggedIn() ) ? <Link to="/stanPass">Stan passepartout</Link> :  ''
            }
          </li>
          <li>
            {
              ( isLoggedIn() && (ifAdmin() || ifSprzedawca())  ) ? <Link to="/utarg">Utarg</Link> :  ''
            }
          </li>
          <li>
            {
              ( isLoggedIn() ) ? <Link to="/listwyDoZam">Listwy do Zamówienia</Link> :  ''
            }
          </li>
          <li>
            {
              ( isLoggedIn() && (ifAdmin() || ifSprzedawca())  ) ? <Link to="/dictListwy">Słownik - Listwy</Link> :  ''
            }
          </li>

        </ul>
        <ul className="nav navbar-nav navbar-right">

          <li>
           {
             (isLoggedIn()) ? ( <button className="btn btn-danger log" onClick={() => logout()}>Wyloguj</button> ) : ( <button className="btn btn-info log" onClick={() => login()}>Zaloguj</button> )
           }
          </li>
        </ul>
      </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js